<div class="screening-dialog">
  <button type="button" class="screening-dialog__close" [disabled]="uploading" (click)="close()"
    aria-label="Close">×</button>
  <h2 class="screening-dialog__title" [translate]="titleKey"></h2>
  <p class="screening-dialog__intro" [translate]="introKey"></p>
  @for (docType of docTypes; track docType) {
  <div class="screening-dialog__field">
    <span class="screening-dialog__label" [translate]="docLabel(docType)"></span>
    <p class="screening-dialog__hint" [translate]="docHint(docType)"></p>
    @if (docType === DocType.Certificate) {
    <p class="screening-dialog__line"
      [innerHTML]="'texts.Screening_Certificate_Template_Line' | translate: { url: certificateTemplateUrl }"></p>
    <p class="screening-dialog__line"
      [innerHTML]="'texts.Screening_Certificate_Guide_Line_New' | translate: { url: certificateGuideUrl }"></p>
    @if (!reminder) {
    <p class="screening-dialog__line">
      <strong translate>texts.Screening_Certificate_Reimbursement_Bold</strong>&ngsp;<span
        translate>texts.Screening_Certificate_Reimbursement_Text</span>
    </p>
    }
    }
    <label class="screening-dialog__upload" [class.screening-dialog__upload--filled]="selectedFiles.has(docType)"
      [class.screening-dialog__upload--disabled]="uploading"
      [class.screening-dialog__upload--dragging]="draggingOver === docType" (dragover)="onDragOver(docType, $event)"
      (dragleave)="onDragLeave(docType)" (drop)="onDrop(docType, $event)">
      <input class="screening-dialog__file-input" type="file" accept="application/pdf" [disabled]="uploading"
        (change)="onFileSelected(docType, $event)" />
      <svg class="screening-dialog__upload-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="17 8 12 3 7 8" />
        <line x1="12" y1="3" x2="12" y2="15" />
      </svg>
      @if (selectedFiles.get(docType); as file) {
      <span class="screening-dialog__upload-text">{{ file.name }}</span>
      } @else {
      <span class="screening-dialog__upload-text" translate>texts.Screening_Choose_File</span>
      }
    </label>
  </div>
  }
  @if (error) {
  <p class="screening-dialog__error" [translate]="error"></p>
  }
  <div class="screening-dialog__actions">
    <button class="screening-dialog__submit" type="button" [disabled]="!canSubmit" (click)="submit()">
      @if (uploading) {
      <mat-spinner [diameter]="18"></mat-spinner>
      } @else {
      <span [translate]="submitKey"></span>
      }
    </button>
    @if (reminder) {
    <button class="screening-dialog__later" type="button" [disabled]="uploading" (click)="close()"
      translate>texts.Screening_Reminder_Dialog_Later</button>
    }
  </div>
  <p class="screening-dialog__footer" translate>texts.Screening_Footer_Retention</p>
  @if (!reminder) {
  <p class="screening-dialog__footer" translate>texts.Screening_Footer_Review</p>
  }
</div>
